module.exports = __webpack_public_path__ + "media/images/common/project_off_right-4399233d62f545b39b1ce57714bab0d7.png";